
export function logOut(userType) {
    return new Promise((res, rej) => {
        window.localStorage.removeItem(userType);
        res(true);
    });
  }
  
  export function isLoggedIn(userType) {
    let session = getObject(userType) || {};
    session = Object.keys(session).length && JSON.parse(session)
    // console.log("session", session)
  
    let accessToken = session && session && session['jwtToken'] || "";
    // console.log("access",accessToken)
    return accessToken;
  }
  
  export function getObject(key) {
    // console.log(key)
    if (window && window.localStorage) {
        return window.localStorage.getItem(key);
    }
  }
  
  export function multiPartData(data, type=''){
    // console.log(data)
    let multiPart = new FormData();
    for (let key in data){
       if(type === 'multiple' &&  key === 'blogImage') {
          data[key].forEach(file=>{
          multiPart.append(key, file);
        });
       
       } else if(key !== 'blogImage') {
        multiPart.append(key,data[key])
        }
    }
  
    return multiPart
  }
  
  export function checkPassword(str)
  {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
  }
  

 export  const addLeadingZero = (num) => {
  if (num === 0) return "00";
  if (num < 10) return "0" + num;
  return String(num);
};


export const compressImage = (file, quality = 0.7, maxWidth = 1024) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");

        // 👉 resize logic
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          const ratio = maxWidth / width;
          width = maxWidth;
          height = height * ratio;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // 👉 convert to compressed blob
        canvas.toBlob(
          (blob) => {
            const compressedFile = new File([blob], file.name, {
              type: "image/jpeg",
              lastModified: Date.now(),
            });

            resolve(compressedFile);
          },
          "image/jpeg",
          quality // 👉 0.5–0.8 best
        );
      };

      img.onerror = (err) => reject(err);
    };

    reader.onerror = (err) => reject(err);
  });
};